import base from '../base/base.js'

// 分享mixin
/*  1. 引入该mixin    
    mixins: [app.mixin.share]
    2. 在合适的时机调用this.app_share_resolve方法, 传入分享参数;
    如:
    created() {
        this.app_share_resolve({
            title: '我是标题',
            desc: '我是要分享的描述信息、内容。。。',
            link: location.href,
            imgUrl: 'http://static.dingtalk.com/media/lADPBbCc1YOadDfNAoDNAoA_640_640.jpg'
        })
    }*/
export const share = {
    data() {
        return {
            app_share_options: "",
        }
    },
    created: function () {
        let sharePromise = new Promise(resolve => this.app_share_resolve = resolve)

        if (base.env === 'wxxcx') {
            this.v_updateShareMessage()
        }

        this.$on('pageshow', () => {
            // console.log(">>>>> pageshow");
            sharePromise.then(options => {
                this.app_share_options = options
                this.v_updateShareMessage()
            })
        })
    },
    methods: {
        v_updateShareMessage() {
            let opts = this.app_share_options
            if (opts) {
                let options = typeof opts === 'function' ?
                    opts() :
                    opts

                if (base.env === 'wxxcx') {
                    base.getEnvSDKPromise.then(() => {
                        console.log("小程序中 分享  触发 ");
                        wx.miniProgram.postMessage({
                            data: {
                                eventType: "share",
                                data: options,
                            }
                        })
                    })
                } else {
                    options && app.sdk.share(options)
                }
            }
        }
    }
}